import { TransportationTrackingActionType } from '../../ui-kit';
import { TransportMode } from '../constants';
import { DateWithTimezones } from './status-history-chain.model';

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export interface PointData {
  viewType: MapStopType;
  latitude: number;
  longitude: number;
  dateTime: DateWithTimezones;
  extId: string;
  name: string;
  address: string;
  actions: MapStopActionType[];
  sortIndex: string;
}

export interface MapPointActions extends Coordinates {
  actions: MapStopActionType[];
}

export class MapPoint implements Coordinates {
  latitude: number;
  longitude: number;
  dateTime: DateWithTimezones;
  sortIndex: string;
}

export interface GpsPoint extends MapPointActions, MapPoint {
  viewType: MapStopType;
  dateTime: DateWithTimezones;
  sortIndex: string | null;
}

export enum MapStopType {
  Stop = 'STOP',
  Point = 'POINT',
}

export class MapStopBase {
  address: string;
  isPassed: boolean;
  latitude: number;
  longitude: number;
  name: string;
}

export class MapStop extends MapStopBase implements Coordinates {
  actions: TransportationTrackingActionType[];
}

export class MapTrackingPoints<Stop, Point> {
  stops: Stop[];
  points: Point[];
}

export class MapTrackingGpsPoints<GpsPointType> {
  stops: MapStop[];
  points: MapPoint[];
  gpsPoints: GpsPointType[];
}

export class MapStopActionType {
  action: TransportationTrackingActionType;
  isPassed: boolean;
}

export class WaybillMapStop implements PointData {
  actions: MapStopActionType[];
  transportMode: TransportMode;
  extId: string | null;
  dateTime: DateWithTimezones;
  viewType: MapStopType;
  sortIndex: string;
  address: string;
  latitude: number;
  longitude: number;
  name: string;
}
